export const SERVER_URL = "http://localhost:8080/api/";
export const FE_SERVER_URL = "http://localhost:3000/";
export const ADMIN = "Admin";
export const STRIPE_PUBLIC_KEY =
  "pk_test_51JHwa2SI7mxpZ73yIcFktUdwRLMr8zEjqrGemre4Gn3V5DfmEH0qzmJZxgLA6yGLxj699sZCaAyaaoAwyQGuiiMJ00UKxraY7q";
